import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-dialogs-errors',
  templateUrl: './dialogs-errors.component.html',
  styleUrls: ['./dialogs-errors.component.scss']
})
export class DialogsErrorsComponent implements OnInit {

  erreurperiode: any;

  constructor(
    public dialogRef: MatDialogRef<DialogsErrorsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.erreurperiode = this.data.erreurperiode;
  }

  parcourir(){
    console.log("parcourir")
    this.dialogRef.close({parcourir:true});
  }

  dismissDialog(){
      this.dialogRef.close();
  }

}
